
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oplata-za-gospodarowanie-odpadami-komunalnymi",
      function () {
        return require("private-next-pages/oplata-za-gospodarowanie-odpadami-komunalnymi/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oplata-za-gospodarowanie-odpadami-komunalnymi"])
      });
    }
  